import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import {
  ArrowDownLeft,
  ArrowUpRight,
  Banknote,
  Building,
  Calendar,
  FileText,
  Printer,
  Download,
  Receipt,
  CheckCircle,
  Loader2,
} from "lucide-react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaExchangeAlt,
  FaStickyNote,
  FaGlobe,
  FaCity,
  FaMapMarkerAlt,
  FaBuilding,
  FaLocationArrow,
  FaTruck,
  FaUserTie,
} from "react-icons/fa";
import PDCOpenPopup from "./PDCOpenPopup";
import axios from "axios";
import PDCReportPrint from "./PDCReportPrint";


const PDCReports = ({ searchTerm }) => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const roles = [
    { id: "value-1", label: "PDC Received", mode: "PDC_R" },
    { id: "value-2", label: "PDC Issued", mode: "PDC_I" },
    { id: "value-3", label: "PDC Received As On Date", mode: "PDC_R_D" },
    { id: "value-4", label: "PDC Issued As On Date", mode: "PDC_I_D" },
  ];

  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [transferDate, setTransferDate] = useState(null);
  const [openPDC, setOpenPDC] = useState(false);
  const [selected, setSelected] = useState("value-1");
  const [selectedMod, setSelectedMod] = useState("PDC_R");
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(today);
  const [salesmanList, setSalesmanList] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState("");
  const [includeChecked, setIncludeChecked] = useState(false);
  const [isPDCReportPrint, setIsPDCReportPrint] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchCompanyInfo();
    fetchBanks();
  }, []);

  const fetchPDCReportList = async (mod, strtDt, endDate) => {
    setLoading(true);
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMPDCReports/${COMPANY_CODE}/${mod}/${strtDt}/${endDate}/-/-/-/-/-/-/${
      bankName ? bankName : "-"
    }`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("PDC Reports Data:", data);
      setAccounts(data);
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

   
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setStartDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      fetchPDCReportList(
        "PDC_R",
        dayjs(companyInfoData.fystart).format("YYYY-MM-DD"),
        dayjs(endDate).format("YYYY-MM-DD")
      );
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchBanks = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
   
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/BANK/-/-`;

    try {
      const res = await axios.get(apiUrl);
      setBanks(res.data || []);
    } catch (error) {
      console.error("Error fetching bank list:", error);
    }
  };

  const handleSelectToggle = (index, checked) => {
    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      return updated;
    });
  };

  const handleIncludeChange = (e) => {
    const checked = e.target.checked;
    setIncludeChecked(checked);

    // Call API when checked
    if (checked) {
      fetchPDCReportList(selectedMod, startDate, endDate);
    }
  };

  const handleExport = () => {
    // Define columns with field (data key) and headerName (CSV header)
    const columns = [
      { field: "AMOUNT", headerName: "Amount" },
      { field: "CHQNO", headerName: "Chq No" },
      { field: "CHQDATE", headerName: "Chq Date" },
      { field: "BANK", headerName: "Bank" },
      { field: "PDC_ACC", headerName: "Account" },
      { field: "CNAME", headerName: "Name" },
      { field: "JVTYPE", headerName: "JVType" },
      { field: "DEPTNO", headerName: "Dept No" },
      { field: "duedays", headerName: "Due Days" },
      { field: "TR_SLNO", headerName: "TR Sl No" },
      { field: "TYPE_NO", headerName: "Type No" },
      { field: "COSTCODE", headerName: "Cost Code" },
    ];

    exportToCSV(columns, accounts, "PDC_Reports");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    // Create header row
    const headerRow = columns.map((col) => col.headerName);

    // Create data rows
    const dataRows = exportData.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        // Special formatting for date
        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      })
    );

    // Combine header + data
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filteredAccounts = (searchTerm || "").trim()
    ? accounts.filter((item) => {
        const term = searchTerm.toLowerCase();
        const name = (item.CNAME || "").toLowerCase();
        const typeNo = (item.TYPE_NO || "").toString().toLowerCase();
        const chqNo = (item.CHQNO || "").toString().toLowerCase();
        const amount = (item.AMOUNT || "").toString().toLowerCase();
        return name.includes(term) || typeNo.includes(term) || chqNo.includes(term) || amount.includes(term);
      })
    : accounts;

  return (
    <div className="flex justify-center items-start">
      <div className="w-[26vw] h-[77vh] bg-gradient-to-br from-slate-50 via-white to-slate-50 shadow border-r border-slate-200 p-3 flex flex-col">
        <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
          {/* Role Selection - Custom Radio */}
          <div>
            <div className="space-y-3">
              {roles.map((role) => (
                <label
                  key={role.id}
                  className={`
        relative flex items-center gap-4 px-4 h-12 rounded-xl cursor-pointer
        border-2 transition-all duration-300 ease-out
        ${
          selected === role.id
            ? "bg-gradient-to-r from-indigo-600 to-indigo-700 border-indigo-500 shadow scale-[1.01]"
            : "bg-white border-slate-200 hover:border-slate-300 hover:shadow hover:scale-[0.99]"
        }
      `}
                >
                  <input
                    type="radio"
                    name="value-radio"
                    value={role.id}
                    checked={selected === role.id}
                    onChange={() => {
                      setSelected(role.id);
                      setSelectedMod(role.id);
                      fetchPDCReportList(role.mode, startDate, endDate); // <-- pass the mode to your fetch function
                    }}
                    className="sr-only"
                  />

                  {/* Custom Radio Circle */}
                  <div
                    className={`
          w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200
          ${selected === role.id ? "bg-white" : "bg-slate-300"}
          ${
            selected === role.id ? "ring-4 ring-indigo-400 ring-opacity-30" : ""
          }
        `}
                  >
                    <div
                      className={`
            w-2 h-2 bg-indigo-600 rounded-full transition-transform duration-200
            ${selected === role.id ? "scale-100" : "scale-0"}
          `}
                    />
                  </div>

                  <p
                    className={`text-sm transition-colors ${
                      selected === role.id ? "text-white" : "text-slate-700"
                    }`}
                  >
                    {role.label}
                  </p>

                  {/* Pulse on select */}
                  {selected === role.id && (
                    <div className="absolute inset-0 rounded-xl bg-indigo-400 opacity-0" />
                  )}
                </label>
              ))}
            </div>

            <div className="flex my-4  justify-center items-center">
              <div className="flex-1 ml-2">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  <Building className="w-4 h-4 mr-2 text-gray-600" />
                  Banks
                </label>

                <select
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                  className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
                >
                  <option value="">Select Bank...</option>
                  {banks.map((bank) => (
                    <option key={bank.Bank_ID} value={bank.Bank_ID}>
                      {bank.Bank_Name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-3 mt-6 ml-4">
                <label className="text-xs font-semibold ">Apply Filter</label>
                <label className="relative inline-block w-[3.5em] h-[1.95em]">
                  <input
                    type="checkbox"
                    className="peer sr-only"
                    checked={isApplyFilter}
                    onChange={(e) => setIsApplyFilter(e.target.checked)}
                  />
                  <span
                    className="
                                                  absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                                                  after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                                                  after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                                                  after:transition-all after:duration-300 after:ease-in-out
                                                  after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                                                  peer-checked:bg-blue-500
                                                  peer-checked:after:translate-x-[1.5em]
                                                  peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                                                  peer-active:after:w-[3em]
                                                  peer-checked:peer-active:after:translate-x-[0.5em]
                                                "
                  ></span>
                </label>
              </div>
            </div>
            {isApplyFilter && (
              <div>
                <label className="text-xs font-semibold mr-2">Include</label>

                <input
                  type="checkbox"
                  className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                  checked={includeChecked}
                  onChange={handleIncludeChange}
                />
                <div className="flex justify-center items-center gap-1 mt-8 ">
                  <div className="flex-1">
                    <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                      <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                      Start Date
                    </label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full px-3 py-2.5 text-sm bg-gray-100  border border-gray-300  rounded-lg 
                               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                               transition-all duration-200"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                      <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                      End Date
                    </label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full px-3 py-2.5 text-sm bg-gray-100 border border-gray-300  rounded-lg 
                               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                               transition-all duration-200"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Action Buttons: Print & Export */}
          <div className="flex gap-3 py-2">
            <button
              onClick={() => setIsPDCReportPrint(true)}
              className="flex-1 flex items-center justify-center gap-2 
                                   bg-teal-500 text-white 
                                   font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
            >
              <Printer className="w-4 h-4" />
              Print
            </button>

            <button
              onClick={handleExport}
              className="flex-1 flex items-center justify-center gap-2 
                                   bg-cyan-600 text-white 
                                   font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
            >
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="w-full h-[77vh] overflow-auto shadow relative">
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-20">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
        )}
        <table className="relative text-xs border-collapse w-full ">
          <thead>
            <tr>
              {/* <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-10">
                Select
              </th> */}
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Amount
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Chq No
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Chq Date
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Bank
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Account
              </th>
              <th className="bg-gray-100 w-60 font-normal sticky top-0 border px-2 py-1">
                Name
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                JVType
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Dept No
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Due Days
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                TR Sl No
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Type No
              </th>
              <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                Cost Code
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredAccounts?.length > 0 ? (
              filteredAccounts.map((acc, index) => (
                <tr key={acc?.TR_SLNO || index} className="text-xs">
                  {/* Toggle / Select */}
                  {/* <td className="border w-[100] text-center bg-white">
                    <label className="relative inline-block w-[3.5em] h-[2.1em]">
                      <input
                        type="checkbox"
                        className="peer sr-only"
                        checked={!!selectedToggle[index]}
                        onChange={(e) =>
                          handleSelectToggle(index, e.target.checked)
                        }
                      />
                      <span
                        className="
                  absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                  after:content-[''] after:absolute after:top-[4px] after:left-[4px]
                  after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                  after:transition-all after:duration-300 after:ease-in-out
                  after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                  peer-checked:bg-blue-500
                  peer-checked:after:translate-x-[1.5em]
                  peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                  peer-active:after:w-[3em]
                  peer-checked:peer-active:after:translate-x-[0.5em]
                "
                      ></span>
                    </label>
                  </td> */}

                  <td className="border bg-white px-2 py-1 text-right">
                    {acc?.AMOUNT ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-right">
                    {acc?.CHQNO ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.CHQDATE
                      ? dayjs(acc.CHQDATE).format("DD/MM/YYYY")
                      : "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-left">
                    {acc?.BANK ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.PDC_ACC ?? "-"}
                  </td>
                  <td className="border w-60 bg-white px-2 py-1 text-left">
                    {acc?.CNAME ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.JVTYPE ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.DEPTNO ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.duedays ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.TR_SLNO ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.TYPE_NO ?? "-"}
                  </td>
                  <td className="border bg-white px-2 py-1 text-center">
                    {acc?.COSTCODE ?? "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={13} className="text-center py-4 text-gray-500">
                  No outstanding data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isPDCReportPrint && (
        <div className="m-6">
          <PDCReportPrint
            pdcReportPrintDataFromAPI={accounts}
            setIsPDCReportPrint={setIsPDCReportPrint}
            isPDCReportPrint={isPDCReportPrint}
          />
        </div>
      )}
    </div>
  );
};

export default PDCReports;
